import { ButtonBase, ButtonBaseProps, SxProps, Theme } from '@mui/material';
import { ReactNode } from 'react';

import { selectablePanelRootSx, selectablePanelSelectedSx } from './selectable-panel-styles';

export type SelectablePanelProps = Omit<ButtonBaseProps, 'sx' | 'children'> & {
  /** Whether this panel is the currently selected item. */
  selected?: boolean;
  children?: ReactNode;
  sx?: SxProps<Theme>;
};

/**
 * Interactive surface for selectable rows in master–detail / sidebar panels.
 * Supports idle, hover, selected, and selected+hover states without media-card layout.
 */
export function SelectablePanel({
  selected = false,
  children,
  sx,
  disabled,
  ...buttonProps
}: SelectablePanelProps) {
  return (
    <ButtonBase
      disableRipple
      disabled={disabled}
      {...buttonProps}
      sx={
        [
          selectablePanelRootSx,
          ...(selected ? [selectablePanelSelectedSx] : []),
          ...(sx !== undefined ? (Array.isArray(sx) ? sx : [sx]) : []),
        ] as SxProps<Theme>
      }
    >
      {children}
    </ButtonBase>
  );
}
